<div class="users-container">
    <app-form-row>
      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Doctors'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{userCount}}</label>
          </div>
        </div>
      </app-card-sm-container>

      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Clinics'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{clinicCount}}</label>
          </div>
        </div>
      </app-card-sm-container>
    </app-form-row>

    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Number Of Doctors'">
        </app-label>
        <app-textbox
            [placeholder]="''"
            [control]="usersControl">
        </app-textbox>
    </app-form-row>

    <app-button [button]="createUserButton">
    </app-button>
    <br>
    <mat-divider></mat-divider>
    <br>
    <div class="button-container">
        <app-button [button]="createClinicProfileButton">
        </app-button>
        <app-button [button]="createKeywordsButton">
        </app-button>
        <app-button [button]="createExpiredSubscriptionButton">
        </app-button>
    </div>
</div>